/**
 * THE sideways-scroll edge fade — one rule for "more content is off this
 * edge", shared by `ui/Tabs` (`scrollHints`, 2026-09-30) and
 * `ui/PageScrollTable` (phone tables, owner 2026-10-03: "add a slight fade to
 * the table at the edge where it scrolls off the page to signify it scrolls").
 *
 * A CSS MASK, never an overlay: it fades what is painted and takes no part in
 * hit-testing, so it cannot swallow a tap. Transparent at an edge with more
 * content behind it, opaque everywhere else; no fade on an edge that is fully
 * scrolled, and none at all when nothing overflows.
 */
export const EDGE_FADE_PX = 24;

/** `{ left, right }` for a horizontal scroll box: which edges hide content. */
export function readEdgeFade(el) {
  if (!el || el.scrollWidth <= el.clientWidth + 1) return { left: false, right: false };
  return {
    left: el.scrollLeft > 1,
    right: el.scrollLeft + el.clientWidth < el.scrollWidth - 1,
  };
}

/** The mask gradient for a `{ left, right }` state. */
export function edgeFadeMask({ left, right }, px = EDGE_FADE_PX) {
  const l = left ? `transparent 0, #000 ${px}px` : '#000 0';
  const r = right ? `#000 calc(100% - ${px}px), transparent 100%` : '#000 100%';
  return `linear-gradient(to right, ${l}, ${r})`;
}
